import * as React from 'react';

export default (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19.7 14a8 8 0 0 0 .3-2V5l-8-3-3.2 1.2" />
    <path d="M4.7 4.7 4 5v7c0 6 8 10 8 10a16 16 0 0 0 4-2.3" />
    <path d="m2 2 20 20" />
  </svg>
);
